import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DownloadExcel = (columns, data, tableName) => {
  let wsData;

  if (tableName === "Role_Managment" || tableName === "Employee_Managment") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item) => [
        item.sl,
        item.name,
        item.description,
        item.updatedby,
        item.lastupdateby
      ])
    ];
  }

  if (tableName === "Bonus_Report") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        index + 1,
        item?.employeeId,
        item?.name,
        item?.role,
        item?.enrollmentCount
      ])
    ];
  }

  if (tableName === "Refer_and_Earn") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        index + 1,
        item?.name,
        item?.createdAt,
        item?.email,
        item?.phoneNumber,
        item?.country,
        item?.referredBy,
        item?.status
      ])
    ];
  }

  if (tableName === "Incentive_Report") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        index + 1,
        item?.universityName,
        item?.studentName,
        item?.university,
        item?.course,
        item?.date,
        item?.status
      ])
    ];
  }

  if (tableName === "Allapplication_Management") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        index + 1, // Sl no
        item?.lead?.firstName || "", // Student name
        item?.lead?.lead_personal_details?.[0]?.passportNumber || "", // Passport Number
        item?.lead?.email || "", // Email
        item?.lead?.mobileNumber || "", // Phone Number
        item?.universityCountry || "", // Country
        item?.courseName || "", // Course
        item?.universityName || "", // University
        item?.universityHandlerId || "", // University Handler
        item?.lead?.leadOwnerName || "", // Lead owner
        item?.lead?.Counselor?.firstName || "", // Counsilor
        item?.lead?.Telecaller?.firstName || "", // Telecaller
        item?.intakeDate || "", // Intake
        item?.createdAt || "", // Application Started Date
        item?.methodStatus || "", // Status
        item?.lead?.deferalIntakeMonth || "", // Deferal intake month
        item?.lead?.deferalIntakeYear || "", // Deferal intake year
        item?.paymentStatus || "" // Payment status
      ])
    ];
  }

  if(tableName === "dead_Management") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item) => [
        item?.sl,
        item?.name,
        item?.email,
        item?.phone,
        item?.whatsappNumber,
        item?.preferredCountry,
        item?.leadSource,
        item?.leadOwner,
        item?.leadBranch,
        item?.status,
        item?.priority,
        item?.leadCity,
        item?.leadTeleCaller,
        item?.leadCounsilor,
        item?.reason
      ])
    ]
  }

  if (tableName === "Lead_Managment") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item) => [
        item?.sl,
        item?.name,
        item?.email,
        item?.phone,
        item?.whatsappNumber,
        item?.passportNumber,
        item?.preferredCountry,
        item?.leadSource,
        item?.leadOwner,
        item?.leadBranch,
        item?.status,
        item?.priority,
        item?.leadCity,
        item?.leadTeleCaller,
        item?.leadCounsilor,
      ])
    ];
  }

  if (tableName === "Drop_Management") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item) => [
        item?.sl,
        item?.name,
        item?.email,
        item?.phone,
        item?.whatsappNumber,
        item?.preferredCountry,
        item?.leadSource,
        item?.leadOwner,
        item?.leadBranch,
        item?.status,
        item?.priority,
        item?.leadCity,
        item?.Reason,
        item?.leadTeleCaller,
        item?.leadCounsilor,
      ])
    ];
  }

  if (tableName === "deferral_Managment") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item) => [
        item?.sl,
        item?.name,
        item?.email,
        item?.phone,
        item?.whatsappNumber,
        item?.leadSource,
        item?.leadCity,
        item?.prefferedCountry,
        item?.leadBranch,
        item?.intakeMonth,
        item?.intakeYear,
        item?.leadTeleCaller,
        item?.leadCounsilor,
      ])
    ];
  }

  if (tableName === "Enrolled_Application_Management") {
    wsData = [
      columns.map((item) => [item.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.lead?.firstName,
        item?.lead?.lead_personal_details[0]?.passportNumber,
        item?.lead?.email,
        item?.lead?.mobileNumber,
        item?.universityCountry,
        item?.courseName,
        item?.universityName,
        item?.user?.firstName,
        item?.intakeDate,
        item?.createdAt,
        item?.methodStatus,
        item?.paymentStatus
      ])
    ];
  }

  if (tableName === "All_Employee_Managment") {
    wsData = [
      columns.map((item) => [item.title]),
      ...data.map((item) => [
        item.sl,
        item?.employeeId,
        item?.name,
        item?.description,
        item?.updatedby,
        item?.lastupdateby,
        item?.branch,
        item?.status
      ])
    ];
  }

  if (tableName === "Deal_Managment") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item) => [
        item?.sl,
        item?.name,
        item?.email,
        item?.phone,
        item?.whatsappNumber,
        item?.passportNumber,
        item?.preferredCountry,
        item?.leadSource,
        item?.leadOwner,
        item?.leadBranch,
        item?.status,
        item?.priority,
        item?.leadCity,
        item?.leadTeleCaller,
        item?.TeleCallerNote,
        item?.leadCounsilor,
        item?.CounsilorNote,
        item?.marketingNote
      ])
    ];
  }

  if (tableName === "Partner_Create_Management") {
    wsData = [
      columns.map((item) => [item.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        index + 1,
        item?.name,
        item?.email,
        item?.phone,
        item?.user?.firstName,
        item?.isVerified ? "Verified" : "Not Verified"
      ])
    ];
  }

  if (tableName === "Partner_enrolled_Management") {
    wsData = [
      columns.map((item) => item?.title),
      ...data.map((item, index) => [
        index + 1,
        item?.lead?.firstName || "",
        item?.universityCountry || "",
        `${item?.courseLevel} - ${item?.courseName}` || "",
        item?.lead?.partner?.name || "",
        item?.lead?.partner?.user?.firstName || "",
        item?.UserTeamLeadStaff?.firstName || "",
        item?.intakeDate || "",
        item?.methodStatus || ""
      ])
    ];
  }

  if (tableName === "Hr_Jobvacancies_Managment") {
    wsData = [
      columns.map((item) => [item?.title]), // Wrap each title in a sub-array
      ...data.map((item) => [
        item?.sl,
        item?.coloum1,
        item?.coloum2,
        item?.coloum3,
        item?.coloum4,
        item?.coloum5,
        item?.coloum6
      ])
    ];
  }

  if (tableName === "Entrolledstudentslist") {
    wsData = [
      columns.map((item) => [item?.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        item?.sl,
        item?.coloum1,
        item?.coloum2,
        item?.coloum3,
        item?.coloum4,
        item?.coloum5,
        item?.coloum6,
        item?.coloum7,
        item?.coloum8,
        item?.coloum9,
        item?.coloum10
      ])
    ];
  }

  if (tableName === "EntrolledTeacherList") {
    wsData = [
      columns.map((item) => [item?.title]), // Wrap each title in a sub-array
      ...data.map((item, index) => [
        item?.sl,
        item?.coloumn1,
        item?.coloumn2,
        item?.coloumn3,
        item?.coloumn4,
        item?.coloumn5,
        item?.coloumn6
      ])
    ];
  }

  if (tableName === "OnlinePurchasedStudentList") {
    wsData = [
      columns.map((item) => [item.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.ielts_entrolled_student?.fullName,
        item?.ielts_entrolled_student?.dob,
        item?.ielts_entrolled_student?.gender,
        item?.ielts_entrolled_student?.email,
        item?.ielts_entrolled_student?.phoneNumber,
        item?.ielts_entrolled_student?.whatsAppNumber,
        item?.ielts_course?.CourseName,
        item?.ielts_entrolled_student?.status
      ])
    ];
  }

  if (tableName === "OfflinePurchasedStudentList") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.ielts_entrolled_student?.fullName,
        item?.ielts_entrolled_student?.dob,
        item?.ielts_entrolled_student?.gender,
        item?.ielts_entrolled_student?.email,
        item?.ielts_entrolled_student?.phoneNumber,
        item?.ielts_entrolled_student?.whatsAppNumber,
        item?.ielts_course?.CourseName,
        item?.ielts_center?.CenterName,
        item?.payment,
        item?.ielts_teacher?.teacherName,
        item?.ielts_entrolled_student?.status
      ])
    ];
  }

  if (tableName === "ALL_TICKETS_TABLE") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.ielts_entrolled_student?.fullName,
        item?.ielts_entrolled_student?.dob,
        item?.ielts_entrolled_student?.gender,
        item?.ielts_entrolled_student?.email,
        item?.ielts_entrolled_student?.phoneNumber,
        item?.ielts_entrolled_student?.whatsAppNumber,
        item?.ielts_course?.CourseName,
        item?.ielts_center?.CenterName,
        item?.payment,
        item?.ielts_teacher?.teacherName,
        item?.ielts_entrolled_student?.status
      ])
    ];
  }

  if (tableName === "Employee_Managment") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.ielts_entrolled_student?.fullName,
        item?.ielts_entrolled_student?.dob,
        item?.ielts_entrolled_student?.gender,
        item?.ielts_entrolled_student?.email,
        item?.ielts_entrolled_student?.phoneNumber,
        item?.ielts_entrolled_student?.whatsAppNumber,
        item?.ielts_course?.CourseName,
        item?.ielts_center?.CenterName,
        item?.payment,
        item?.ielts_teacher?.teacherName,
        item?.ielts_entrolled_student?.status
      ])
    ];
  }

  if (tableName === "sceduledMeeting") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.name,
        item?.counsilorName,
        item?.sceduledDate,
        item?.sceduledTime,
        item?.status
      ])
    ];
  }

  if (tableName == "Role_Managment") {
    wsData = [
      columns.map((item) => [item?.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.name,
        item?.description,
        item?.bulkID,
        "admin",
        item?.lastupdateby
      ])
    ];
  }

  if (tableName === "slotList") {
    wsData = [
      columns.map((item) => [item.title]),
      ...data.map((item, index) => [
        index + 1,
        item?.date,
        item?.slotTimes?.[0]
          ? `${item.slotTimes[0].timeFrom} - ${item.slotTimes[0].timeTo}`
          : "",
        item?.user?.firstName,
        item?.status
      ])
    ];
  }

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Create a workbook for Excel
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

  // Convert the workbook to a Blob object (type "blob" is assumed by default)
  const excelBlob = XLSX.write(wb, { bookType: "xlsx", type: "buffer" });

  // Download the Excel file using FileSaver.js
  saveAs(
    new Blob([excelBlob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }),
    `${tableName}.xlsx`
  );
};

export default DownloadExcel;
